/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable require-jsdoc */
import React, { useEffect, useMemo, useState, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import {
  Edit,
  Delete,
  CloudUpload,
  RemoveCircleOutline,
  Visibility,
  PrintRounded,
  GetAppRounded,
  Email,
  Done,
  Clear,
  MoreVert,
  Flag,
} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import * as FinloComponent from "../index";
import ValidationLibrary from "../../utils/validationfunction";
import Empty from "antd/es/empty";
import "./table.scss";
import { FileConverter, File, Undo, PaymentStatus } from "../../images";
import { getNodeText } from "../../utils/common";
import { renderInvoicePaymentStatusInTable } from "../../utils/invoiceStatusDisplay";
import { Grid } from "@material-ui/core";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

const TablePaginationActions = (props) => {
  const classes = useStyles1();
  const theme = useTheme();

  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

/**
 * @function descendingComparator used for descendingComparator action
 * @param {string} a input value
 * @param {string} b input value
 * @param {string} orderBy input value
 * @returns {string} value
 */
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

/**
 * @function getComparator used for descendingComparator action
 * @param {string} order input value
 * @param {string} orderBy input value
 * @returns {string} value
 */
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 * @function stableSort used for descendingComparator action
 * @param {string} array input value
 * @param {string} comparator input value
 * @returns {string} value
 */
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const EnhancedTableHead = (props) => {
  const { classes, order, orderBy, onRequestSort, headCells, EnableSno } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead className={`c`}>
      <TableRow>
        {EnableSno && (
          <TableCell padding="checkbox" className="tableHeadsno">
            S.No.
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            // hideSortIcon={headCell.id?true:false}
          >
            {headCell.id ? (
              <TableSortLabel
                active={props.sort && orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                className={props.sort ? null : classes.nopointer}
                hideSortIcon={orderBy === headCell.id}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              <>{headCell.label}</>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // paddingTop: "1.2rem",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  inactiveSortIcon: {
    display: "none",
  },
  default: {
    color: "#EE8E54",
    alignItems: "center",
    fontSize: "20px",
    fontWeight: 600,
  },
  NormalTable: {
    color: "black",
  },
  nopointer: {
    cursor: "unset !important",
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const INLINE_ACTION_TYPES = [
  "edit",
  "editStatus",
  "delete",
  "update",
  "convert",
  "print",
  "download",
  "email",
  "done",
  "file",
  "undo",
  "close",
  "paymentStatus",
  "pay",
];

const ACTION_MENU_LABELS = {
  print: "Print",
  email: "Email",
  delete: "Delete",
  pay: "Pay",
};

const RowMoreActionsMenu = ({
  menuActions,
  row,
  actionIndex,
  onActionClick,
  restrictActionIcon,
  iconMap,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleActions = (menuActions || []).filter(
    (action) => !restrictActionIcon || row?.enabledActions?.[action],
  );

  if (!visibleActions.length) return null;

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        className="row-action-more-btn"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        aria-label="More actions"
      >
        <MoreVert fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        getContentAnchorEl={null}
        PaperProps={{ className: "row-action-menu-paper" }}
        MenuListProps={{ className: "row-action-menu-list" }}
      >
        {visibleActions.map((action) => (
          <MenuItem
            key={action}
            className={`row-action-menu-item ${action}`}
            onClick={() => {
              onActionClick(action, row, actionIndex);
              handleClose();
            }}
          >
            <ListItemIcon className={action}>{iconMap[action]}</ListItemIcon>
            <ListItemText primary={ACTION_MENU_LABELS[action] || action} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const EnhancedTable = ({
  header, //FYR:: contains array of object with header id and header name eg:[{id:1,label:"Name"},{id:2,label:"Age"},]
  data, //FYR:: contains array of objects determines table's row and each attribute determines table cell eg:data=[{name:"",age:"",..},{name:"",age:"",..}]
  title, //FYR:: title of table's framebox
  aligncss, //FYR:: common classname for entire table
  EnableSno, //FYR:: shows S.No for all rows in table
  totalCount, // optional: used for pagination footer "of X" instead of rows.length
  disableID,
  actions, //FYR:: contains array of icons name to be displayed under Action column eg:actions=["edit","delete",..]. NOTE: mandatory to give icon name here even incase of restrictActionIcon props
  menuActions, //FYR:: actions shown in a three-dot overflow menu (e.g. print, email, delete, pay)
  onActionClick, //FYR:: callback func when action icons click event fired
  search, //FYR:: shows searchbox for table data search sorting
  fields, //FYR:: contains array of labelbox fields with respective attributes for respective column eg:fields=[{type:"text",labelname:"Name"..},{type:"checkbox"..}]
  actionElements, //FYR:: contains custom node rendered at top of table head
  variant, //FYR:: variant of framebox determines size of table's framebox title eg:variant="small"
  customRow, //FYR:: contains node consist of custom no of TableCells eg:customRow=<><TableCell rowSpan={8}>Total</TableCell><TableCell rowSpan={2}>$500</TableCell><>. NOTE: A last row of entire row
  actionDefault,
  icons, //FYR:: contains common icons to be displayed for all rows eg:icons={eyeIcon: true,notAvail:true}. NOTE:header=[{id:1,label:""},{id:2,label:""},{id:3,label:"Name"},..etc]
  validateRef, //FYR:: contains a ref to validation table labelbox controls from parent page's onclick event. Returns boolean result of validation in ref.current
  cancelValidate, //FYR:: contains a ref to cancel all validation to initial state from parent page's onclick event
  restrictActionIcon, //FYR:: action icons will show/hide based on individual entry eg:rows=[{name:"",age:""...,enabledActions:{edit:true,delete:true,..},{name:"",age:""...,enabledActions:{download:true,print:true,..}}]
  toggleDisable, //FYR:: disable/enable labelbox controls of particular row on toggling that particular row's checkbox. NOTE: toggling field entry should has toggleDisableCheck attr eg:fields=[{type:checkbox,toggleDisableCheck:true,..}]
  hiddenFields, //FYR:: array contains fields name that do not visible in table eg:hiddenFields=["name","age"]. NOTE: No header/ fields should pass for that columns
  filters, //FYR:: array of objects contains field controls attributes to filter table data eg:filters=[{type:"select",...}...]
  filterCallback, //FYR:: callback function which return onchange value, field key
  fileData,
  showExporter,
  onRowClick, //FYR:: callback func when a row is clicked eg:onRowClick={(row) => {...}}
  initialRowsPerPage,
  // restrictStatusButton,
}) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");

  const rows = useMemo(() => {
    if (!data || !Array.isArray(data)) return [];
    if (!searchText) return data;

    const searchRegex = new RegExp(escapeRegExp(searchText), "i");
    return data.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(getNodeText(row[field])?.toString());
      });
    });
  }, [data, searchText]);

  const effectiveCount =
    typeof totalCount === "number" ? totalCount : rows.length;
  const [selectedRow, setSelectedRow] = React.useState();
  const [rowsPerPage, setRowsPerPage] = React.useState(initialRowsPerPage || 5);
  const [validationList, setValidationList] = React.useState([]);
  const [enabledRows, setEnableRows] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  /**
   * @function escapeRegExp used for escapeRegExp action
   * @param {string} value input field data
   * @returns {string} key input field name
   */
  function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }
  useMemo(() => {
    if (fields) {
      if (!!data.length) {
        const initialValidation = fields.map((_) => {
          return { error: null, errmsg: null };
        });
        if (validationList.length === 0 && data.length === 1) {
          setValidationList([initialValidation]);
        } else if (data.length > validationList.length) {
          const diff = data.length - validationList.length;
          for (let i = 1; i <= diff; i++) {
            validationList.push(initialValidation);
          }
          setValidationList((prevState) => [...prevState]);
        }
      } else {
        setValidationList([]);
      }
    }
  }, [data.length]);

  function onSubmitValidation() {
    if ((validateRef, fields)) {
      let validateRows = toggleDisable
        ? rows.filter((_, index) => enabledRows.includes(`R${index}`))
        : rows;
      const deepList = JSON.parse(JSON.stringify(validationList));
      const filterError = validateRows.filter((item, rowIndex) => {
        const index = toggleDisable
          ? enabledRows[rowIndex].replace("R", "")
          : rowIndex;
        const errorList = Object.entries(item).filter(
          ([key, value], colIndex) => {
            if (!hiddenFields?.includes(key) && fields[colIndex]) {
              const rowValidation = fields[colIndex]?.getValidation
                ? fields[colIndex].getValidation(index, rows)
                : fields[colIndex]?.validation || [];
              const errorcheck = ValidationLibrary.checkValidation(
                value,
                rowValidation,
              );
              if (deepList[index] && deepList[index][colIndex]) {
                deepList[index][colIndex].error = !errorcheck.state;
                deepList[index][colIndex].errmsg = errorcheck.msg;
              }
              return !errorcheck.state;
            }
            return false;
          },
        );
        return !!errorList.length;
      });
      setValidationList(deepList);
      return filterError.length > 0;
    }
    return false;
  }

  function onCancelValidation() {
    const initialValidation = fields.map((_) => {
      return { error: null, errmsg: null };
    });
    setValidationList([[...initialValidation]]);
  }

  if (validateRef) validateRef.current = onSubmitValidation;

  if (cancelValidate) cancelValidate.current = onCancelValidation;

  /**
   * @function checkValidation used for validation purpose of input fileds
   * @param {string} data input field data
   * @param {number} colIndex table field index
   * @param {number} rowIndex table row index
   */
  function checkValidation(data, colIndex, rowIndex) {
    if (!fields[colIndex]) return;
    const rowValidation = fields[colIndex]?.getValidation
      ? fields[colIndex].getValidation(rowIndex, rows)
      : fields[colIndex]?.validation || [];
    const errorcheck = ValidationLibrary.checkValidation(data, rowValidation);
    if (validationList[rowIndex] && validationList[rowIndex][colIndex]) {
      validationList[rowIndex][colIndex] = {
        error: !errorcheck.state,
        errmsg: errorcheck.msg,
      };
      setValidationList([...validationList]);
    }
  }

  const prevDataLengthRef = useRef((data && data.length) || 0);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      // Only reset to first page when the number of rows changes
      if (data.length !== prevDataLengthRef.current) {
        setPage(0);
        prevDataLengthRef.current = data.length;
      }
    } else {
      setPage(0);
      prevDataLengthRef.current = 0;
    }
  }, [data]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name, index) => {
    const selectedIndex = selected.indexOf(name);
    setSelectedRow(index);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // eslint-disable-next-line radix
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  // searchText is defined above

  //-------- To find whether table header has action provision ----------//
  const isAction = useMemo(() => {
    if (header) {
      let actionIndex;
      // const actionIndex = header.findIndex((head) => head.label === "Action");
      const noheaderFields = header.filter((head, index) => {
        if (head.label === "Action" && !actionIndex) actionIndex = index;
        else if (head.label === "") return head;
      });
      const rowIndex = actionIndex - noheaderFields?.length;
      return rowIndex || null;
    }
  }, [header]);

  const changeEnableMode = (rowIndex) => {
    const isEnabled = enabledRows.findIndex((ind) => ind === `R${rowIndex}`);
    if (isEnabled === -1) {
      enabledRows.push(`R${rowIndex}`);
    } else {
      const list = JSON.parse(JSON.stringify(validationList));
      list[rowIndex] = list[rowIndex]?.map((rowitem) => {
        if (rowitem.error) {
          return { error: null, errmsg: null };
        } else return rowitem;
      });
      setValidationList(list);
      enabledRows.splice(isEnabled, 1);
    }
  };

  /**
   * @function escapeRegExp used for escapeRegExp action
   * @param {string} value input field data
   * @returns {string} key input field name
   */
  function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
  };
  useMemo(() => {
    if (filters) setFilterOptions(filters);
  }, [filters]);

  const pagerOptions = React.useMemo(() => {
    const opts = [5, 15, 25];
    if (initialRowsPerPage && !opts.includes(initialRowsPerPage)) {
      return [initialRowsPerPage, ...opts];
    }
    return opts;
  }, [initialRowsPerPage]);

  const onFilterChange = (targetValue, filter, index) => {
    if (filter.type === "checkbox") filterOptions[index].checked = targetValue;
    else filterOptions[index].value = targetValue;
    filterCallback(targetValue, filter.key);
    setFilterOptions([...filterOptions]);
  };
  const ICONS = {
    edit: <Edit fontSize="small" />,
    editStatus: <Flag fontSize="small" />,
    delete: <Delete fontSize="small" />,
    update: <CloudUpload fontSize="small" />,
    convert: <img src={FileConverter} alt="converter" />,
    print: <PrintRounded fontSize="small" />,
    download: <GetAppRounded fontSize="small" />,
    email: <Email fontSize="small" />,
    done: <Done fontSize="small" />,
    file: <img src={File} alt="filr" />,
    undo: <img src={Undo} alt="undo" />,
    close: <Clear fontSize="small" />,
    paymentStatus: <AttachMoneyIcon fontSize="small" />,
    pay: <span>Pay</span>,
  };
  return (
    <div className={classes.root}>
      <FinloComponent.FrameBox title={title} transparent variant={variant}>
        {search && (
          <div className="search_box">
            <FinloComponent.Labelbox
              type="searchbox"
              value={searchText}
              changeData={(e) => requestSearch(e)}
            />
          </div>
        )}
        {actionElements && (
          <div className="action-elements">{actionElements}</div>
        )}
        {!!filterOptions?.length && (
          <Grid
            container
            spacing={2}
            alignItems="center"
            style={{ padding: "5px" }}
          >
            {filterOptions.map((filter, index) => (
              <Grid item xs={12} ms={3} sm={3} lg={2}>
                <FinloComponent.Labelbox
                  {...filter}
                  changeData={(targetValue) =>
                    onFilterChange(targetValue, filter, index)
                  }
                />
              </Grid>
            ))}
            <Grid
              item
              xs={12}
              ms={3}
              sm={3}
              lg={2}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "end",
                flexDirection: "row",
                flexWrap: "nowrap",
              }}
            >
              <FinloComponent.FileFormat fileData={fileData} title={title} />
            </Grid>
          </Grid>
        )}
        {/* {showExporter && (
          <Grid
            item
            md={1}
            xs={12}
            sm={12}
            container
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "end",
              flexDirection: "row",
              flexWrap: "nowrap",
            }}
          >
            <FinloComponent.FileFormat fileData={fileData} title={title} />
          </Grid>
        )} */}
        <TableContainer>
          <Table
            className={`${classes.table} ${aligncss}`}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              EnableSno={EnableSno}
              onRequestSort={handleRequestSort}
        rowCount={effectiveCount}
              headCells={header}
              className={aligncss}
            />
            <TableBody>
              {rows.length > 0 ? (
                stableSort(rows, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const actionIndex = rowsPerPage * page + index;
                    var keys = Object.keys(row);
                    keys = hiddenFields
                      ? keys.filter((item) => !hiddenFields?.includes(item))
                      : keys;
                    const actionKeys = keys.filter((key) =>
                      ["enabledActions", "notAvail"].includes(key),
                    );
                    const arrval = [];
                    var terminator =
                      isAction && isAction !== -1 && actions
                        ? keys.length + 1
                        : keys.length;
                    terminator = !!actionKeys.length
                      ? terminator - actionKeys.length
                      : terminator;
                    for (let m = 0; m < terminator; m++) {
                      if (isAction === m && actions) {
                        // Show action buttons based on action types
                        arrval.push(
                          <TableCell key={`${index}${m}`} align="left">
                            <div className="row-action">
                              {actions.map((action, actionIdx) =>
                                React.isValidElement(action) ? (
                                  <div key={actionIdx}>{action}</div> // Render JSX element directly
                                ) : INLINE_ACTION_TYPES.includes(action) ? (
                                  <div
                                    key={actionIdx}
                                    className={`${
                                      !restrictActionIcon ||
                                      row?.enabledActions?.[action]
                                        ? "show"
                                        : "hide"
                                    } ${action}`}
                                    onClick={(e) => {
                                      // Prevent action click from triggering parent row click.
                                      e.stopPropagation();
                                      onActionClick(action, row, actionIndex);
                                      if (action === "delete")
                                        validationList.splice(index, 1);
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        action === "done"
                                          ? "Mark as paid"
                                          : action === "pay"
                                            ? "Pay"
                                            : action === "paymentStatus"
                                              ? "Payment status"
                                              : action === "editStatus"
                                                ? "Edit status"
                                                : action
                                      }
                                    >
                                      {ICONS[action]}
                                    </Tooltip>
                                  </div>
                                ) : (
                                  <React.Fragment
                                    key={actionIdx}
                                  ></React.Fragment>
                                ),
                              )}
                              {menuActions?.length > 0 && (
                                <RowMoreActionsMenu
                                  menuActions={menuActions}
                                  row={row}
                                  actionIndex={actionIndex}
                                  onActionClick={(action, rowData, idx) => {
                                    // Prevent menu action from triggering parent row click.
                                    onActionClick(action, rowData, idx);
                                    if (action === "delete")
                                      validationList.splice(index, 1);
                                  }}
                                  restrictActionIcon={restrictActionIcon}
                                  iconMap={ICONS}
                                />
                              )}
                            </div>
                          </TableCell>,
                        );
                      } else if (
                        !disableID &&
                        keys[m] !== "notAvail" &&
                        keys[m] !== "enabledActions"
                      ) {
                        // Show SNO or other data cells
                        // Skip rendering if the value is an object (like enabledActions)
                        const cellValue = row[keys[m]];
                        if (
                          typeof cellValue === "object" &&
                          cellValue !== null &&
                          !React.isValidElement(cellValue)
                        ) {
                          continue; // Skip rendering objects that aren't React elements
                        }
                        arrval.push(
                          <TableCell
                            key={`${index}${m}`}
                            align="left"
                            className={fields ? "align-cell-top" : ""}
                          >
                            {fields?.length > 0 && fields[m] ? (
                              <div className="table-field-wrapper">
                                <FinloComponent.Labelbox
                                  {...fields[m]}
                                  type={
                                    fields[m]?.getFieldType
                                      ? fields[m].getFieldType(
                                          actionIndex,
                                          rows,
                                        )
                                      : fields[m]?.type
                                  }
                                  dropdown={
                                    fields[m]?.getFieldType &&
                                    fields[m].getFieldType(
                                      actionIndex,
                                      rows,
                                    ) === "text"
                                      ? []
                                      : fields[m]?.dependentDropdown?.length > 0
                                        ? (fields[m]?.dependentDropdown[
                                            rowsPerPage * page + index
                                          ] ?? [])
                                        : typeof fields[m]?.getDropdown ===
                                            "function"
                                          ? fields[m].getDropdown(
                                              actionIndex,
                                              rows,
                                            )
                                          : fields[m]?.dropdown || []
                                  }
                                  value={
                                    (fields[m]?.fieldKey
                                      ? row[fields[m].fieldKey]
                                      : row[keys[m]]) ||
                                    `${
                                      fields[m]?.type === "label" ? "---" : ""
                                    }`
                                  }
                                  checked={
                                    (fields[m]?.fieldKey
                                      ? row[fields[m].fieldKey]
                                      : row[keys[m]]) || false
                                  }
                                  changeData={(e) => {
                                    // Guard against undefined fields[m]
                                    if (!fields[m]) return;

                                    // Labelbox already passes the value (not event) for both text and select
                                    // Use fieldKey if specified, otherwise use keys[m]
                                    const fieldKey =
                                      fields[m]?.fieldKey || keys[m];
                                    if (fields[m].changeData) {
                                      fields[m].changeData(
                                        e,
                                        fieldKey,
                                        rowsPerPage * page + index,
                                      );
                                    }
                                    if (
                                      fields[m]?.type === "checkbox" &&
                                      fields[m]?.toggleDisableCheck
                                    ) {
                                      changeEnableMode(actionIndex);
                                    } else {
                                      checkValidation(e, m, actionIndex);
                                    }
                                  }}
                                  disabled={
                                    toggleDisable &&
                                    !fields[m]?.toggleDisableCheck
                                      ? !enabledRows.includes(`R${actionIndex}`)
                                      : typeof fields[m]?.getDisabled ===
                                          "function"
                                        ? fields[m].getDisabled(
                                            rowsPerPage * page + index,
                                            rows,
                                          )
                                        : fields[m]?.disabled || false
                                  }
                                  // error={validationList?.[actionIndex]?.[m]?.error}
                                  // errmsg={validationList?.[actionIndex]?.[m]?.errmsg}
                                />
                                {validationList?.[actionIndex]?.[m]?.error && (
                                  <div className="table-error-text">
                                    {validationList?.[actionIndex]?.[m]?.errmsg}
                                  </div>
                                )}
                              </div>
                            ) : row[keys[m]] ? (
                              React.isValidElement(cellValue) ? (
                                <span
                                  className="table-cell-custom"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {cellValue}
                                </span>
                              ) : keys[m] === "status" ||
                                keys[m] === "status_name" ||
                                keys[m] === "payment_status" ||
                                keys[m] === "invoice_status" ? (
                                <span
                                  className="table-cell-custom"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {renderInvoicePaymentStatusInTable(
                                    row,
                                    keys[m],
                                    row[keys[m]],
                                  )}
                                </span>
                              ) : (
                                <div>{row[keys[m]]}</div>
                              )
                            ) : (
                              "---"
                            )}
                          </TableCell>,
                        );
                      }
                    }

                    return (
                      <React.Fragment key={index}>
                        <StyledTableRow
                          hover
                          onClick={(event) => {
                            if (onRowClick) {
                              onRowClick(row, event);
                            } else {
                              handleClick(event, row.name, row.id);
                            }
                          }}
                          style={{
                            cursor: onRowClick ? "pointer" : "default",
                            ...(row._rowStyle || {}),
                          }}
                          role="checkbox"
                          aria-checked={row.id === selectedRow}
                          tabIndex={-1}
                          selected={row.id === selectedRow}
                          className={row._rowClass || ""}
                        >
                          {/* Render S.no */}
                          {EnableSno && (
                            <TableCell align="center">
                              {rowsPerPage * page + index + 1}
                            </TableCell>
                          )}

                          {/* Render eye icon if enabled */}
                          {icons?.eyeIcon && (
                            <TableCell align="center">
                              <div
                                onClick={() =>
                                  onActionClick("eye", row, actionIndex)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <Visibility />
                              </div>
                            </TableCell>
                          )}

                          {/* Render "Not Available" indicator if enabled */}
                          {icons?.notAvail && (
                            <TableCell align="center">
                              {row.notAvail ? (
                                <div className="do-not-disturb">
                                  <RemoveCircleOutline />
                                </div>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                          )}

                          {/* Render other cells */}
                          {arrval}
                        </StyledTableRow>

                        {/* Custom row, if applicable */}
                        {customRow &&
                          rowsPerPage * page + index + 1 === rows.length && (
                            <StyledTableRow>{customRow}</StyledTableRow>
                          )}
                      </React.Fragment>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={12} className="nodatafound">
                    <Empty />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {effectiveCount > 5 && (
          <TablePagination
            classes={{
              root: "db-pager-root",
              toolbar: "db-pager-toolbar",
              caption: "db-pager-caption",
              actions: "db-pager-actions",
              selectRoot: "db-pager-selectRoot",
            }}
            rowsPerPageOptions={pagerOptions}
            component="div"
            count={effectiveCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        )}
      </FinloComponent.FrameBox>
    </div>
  );
};
export default React.memo(EnhancedTable);
